import { IRecoverEmailApi } from "../interface/IForgotEmail";

interface IVerificationCodePayload {
    otpCode: string;
    otpUuid: string;
    brand: string;
}

export const getStateToPayload = (
    verificationCode: string,
    otpUuid: string,
    brand: string
): IVerificationCodePayload => ({
    otpCode: verificationCode,
    otpUuid,
    brand,
});

export interface IRecoverEmailApiResponse {
    email: string;
    verified: boolean;
}

export const getResponseToState = (response: IRecoverEmailApiResponse): IRecoverEmailApi => ({
    email: response.email,
    isVerified: response.verified,
});
